export const routes = {
  LOGIN: "/auth/login",
  REGISTER: "/auth/register",
  LOGOUT: "/auth/logout",
  FORGOT_PASSWORD: "/auth/forgot-password",
  RESET_PASSWORD: "/api/reset-password/:uid/:token",
  CHANGE_PASSWORD: "/auth/change-password",
  PROFILE: "/profile",
  DASHBOARD: "/dashboard",
  USERS: "/users",
  ADVISORS: "/advisors",
  TOPICS: "/topics",
  VALIDATETOPICS: "/validateTopics",
  SETTINGS: "/settings",
  NOTFOUND: "*",
  VIEWTOPICS: "/view-topics",
  REPORT_ISSUE: "/report-an-issue",
  TRANSACTIONS: "/transaction",
};
